import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute() {
  const { isAuthenticated, loading, authMode } = useAuth();
  const location = useLocation();

  // Bypass mode: always allow access
  if (authMode === 'bypass') {
    return <Outlet />;
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    const redirectLocation = location.pathname === '/' ? { ...location, pathname: '/dashboard' } : location;
    return <Navigate to="/login" state={{ from: redirectLocation }} replace />;
  }

  return <Outlet />;
}
